module.exports = __webpack_public_path__ + "static/features-4b3b8e43860a112855a95ed35d0c11da.svg";